import React from 'react';
import _ from 'lodash';

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange
}) => {
  const pages = Math.ceil(totalItems / itemsPerPage);
  const range = _.range(1, pages + 1);
  const numberBounds = 2;
  const boxesToShow = numberBounds * 2 + 1; // 3

  return (
    <div className="gb-pagination">
      {currentPage > 2 &&
        currentPage > numberBounds + 1 &&
        boxesToShow < pages && (
          <a className="nav-arrow" onClick={e => onPageChange(1, e)} href={1}>
            &laquo;
          </a>
        )}
      {currentPage > 1 &&
        boxesToShow < pages && (
          <a
            className="nav-arrow"
            onClick={e => onPageChange(currentPage - 1, e)}
            href={currentPage - 1}
          >
            &lsaquo;
          </a>
        )}
      {range.map((page, i) => {
        return (
          (!(
            i >= currentPage + numberBounds + 1 ||
            i <= currentPage - numberBounds - 1
          ) ||
            pages <= boxesToShow) &&
          (currentPage === page ? (
            <a
              key={page}
              href="{page}"
              className="active"
              onClick={e => onPageChange(page, e)}
            >
              {page}
            </a>
          ) : (
            <a key={page} href={page} onClick={e => onPageChange(page, e)}>
              {page}
            </a>
          ))
        );
      })}
      {currentPage < pages &&
        boxesToShow < pages && (
          <a
            className="nav-arrow"
            onClick={e => onPageChange(currentPage + 1, e)}
            href={currentPage + 1}
          >
            &rsaquo;
          </a>
        )}
    </div>
  );
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination.jsx